import React from "react";
import { Helmet } from "react-helmet";
import styles from "../style.module.scss";
import { PageBanner } from "../../../../components/parts/section";
import { productData } from "../../../../utils/constants";
import { CommonProductPage } from "../../../../components/parts";

const HollowPipes = () => {
  const singleProductData = productData.filter((val) => val.id === 5);
  return (
    <>
      <Helmet>
        <title>HSS Steel Tube Suppliers | Hollow Structural Steel Tube</title>
        <meta
          name="description"
          content="Hollow Steel Tube Supplier- APF is one of the leading metal distributors & providers of metal fabrication in Calgary and the surrounding area."
        />
      </Helmet>
      <div className={styles.productInnerPage}>
        <PageBanner image={singleProductData[0].featured_image} />
        <CommonProductPage
          title={singleProductData[0].name}
          description={singleProductData[0].description}
          features={singleProductData[0].product_feature}
          gallery={singleProductData[0].productGallery}
        />
      </div>
    </>
  );
};

export default HollowPipes;
